// extracted by mini-css-extract-plugin
export default {"board":"board_a56b9ffa1846048688c9","status":"status_a44a59da410962190406","gameboard":"gameboard_d1d2b8b71cfa26eb0ea3"};